exports.sampleLimit = 100;

exports.statCols = [
  {
    id: "CLM_NAME",
    name: "Name",
    align: "left",
    minWidth: 200,
  },
  {
    id: "DATATYPE",
    name: "Data Type",
    align: "left",
    minWidth: 140,
  },
  {
    id: "DISTINCT_VALUES",
    name: "Distinct",
    align: "left",
    minWidth: 90,
  },
  {
    id: "NULL_VALUE",
    name: "Null",
    align: "left",
    minWidth: 90,
  },
  {
    id: "MIN_VALUE",
    name: "Min",
    align: "left",
    minWidth: 90,
  },
  {
    id: "MAX_VALUE",
    name: "Max",
    align: "left",
    minWidth: 90,
  },
];

exports.statColsMini = [
  {
    id: "CLM_NAME",
    name: "Name",
    align: "left",
    minWidth: 110,
  },
  {
    id: "DATATYPE",
    name: "Data Type",
    align: "left",
    minWidth: 90,
  },
  {
    id: "DISTINCT_VALUES",
    name: "Distinct",
    align: "left",
    minWidth: 30,
  },
  {
    id: "NULL_VALUE",
    name: "Null",
    align: "left",
    minWidth: 30,
  },
  {
    id: "MIN_VALUE",
    name: "Min",
    align: "left",
    minWidth: 30,
  },
  {
    id: "MAX_VALUE",
    name: "Max",
    align: "left",
    minWidth: 30,
  },
];
